jQuery(function(){
	jQuery("#mwrInstallationBranch").on('change', function() {
		// Figure out the branch that the user selected from the drop down
		var value = jQuery("#mwrInstallationBranch").val();
		value = value.replace(/\s/g,'');

		// Hide all of the drop downs
		jQuery('.mwrInstallationInstall').each(function(index, el) {
			el.hide();
		});

		// Show the appropriate drop down
		if(value){
			// Value not blank, so show the appropriate drop down
			var valToShow = "#mwrInstallation-" + value;
			jQuery(valToShow).show();
		}	
		else {
			// Show the default drop down
			jQuery('#mwrInstallation-EMPTY').show();
		}
	});
});

jQuery(function(){
	jQuery("#js-generate-link").on('click', function() {
		
		// Check that we have a branch selected
		if(!jQuery("#mwrInstallationBranch").val()){
			alert("You must select a military branch.");
		}
		else {
			var branch = jQuery("#mwrInstallationBranch").val();
			branch = branch.replace(/\s/g,'');
			var installation = jQuery("#mwrInstallation-" + branch).val();

			// Check for installation
			if(!installation){
				alert("You must select a military installation.");
			}
			else {
				// Go ahead and generate the link
				var mwrLink = "http://www.afvclub.com/setBaseID/" + installation;
				jQuery("#mwrLink").val(mwrLink);
				jQuery("#mwrLinkHolder").show();
			}
		}
	});
});